import { DZ_COLOR_GREEN_400, DZ_COLOR_RED_400 } from '@blk/daisy/core/styles';

export class CustomChartUtil {

	/**
	 * When the values in a stacked column chart cannot be contained within the range 0 to 100,
	 * we need to update the axis bounds to ensure that chart values below 0 and above 100 are properly displayed.
	 * Use the method below and override the default `percent` stacking with `normal` stacking to achieve this.
	 * Refer to the `AssetAllocationComponent` for an example of how to use this method.
	 * @param chart The chart to update
	*/
	public static updateAxisBounds(chart: any): void {
		const dataMax = chart.yAxis[0].dataMax;
		const dataMin = chart.yAxis[0].dataMin;

		chart.yAxis[0].update({
			max: Math.max(100, dataMax),
			min: Math.min(0, dataMin)
		});
	}

	/**
	 * This method updates the legend for the risk charts to show portfolio names
	 * @param chart 
	 */
	public static updateRiskLegend(chart: any): void {
		const portfolioNames = chart.xAxis?.[0]?.categories;
		chart.legend.allItems.forEach((item, index) => item.update({ name: portfolioNames?.[index] }));
	}

	/**
	 * This method formats the label for the risk and expected shortfall charts
	 * @param value The value to format
	 * @returns an html string with the formatted value bearing the appropriate color
	 */
	public static getRiskChartFormattedLabel(value: any): string {
		let color;
		if (value.y > 0) {
			color = DZ_COLOR_GREEN_400;
		} else if (value.y < 0) {
			color = DZ_COLOR_RED_400;
		} else {
			color = '#000';
		}
		const formattedValue = (value.y > 0 ? '+' : '') + value.y.toFixed(2) + '%';
		return '<span style="color: ' + color + '">' + formattedValue + ' </span>';
	}

}
